import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const EmotionalRegulation = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >
        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">
          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">
            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Emotional Regulation
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              You can't help what you feel, but you can help what you do
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>
          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="grid lg:grid-cols-2 gap-12 items-start">
              {/* Left Column */}
              <div className="max-w-2xl">
                <p
                  className="text-base text-black leading-relaxed mb-6 mt-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Imagine you're stuck in traffic on the way to an important
                  meeting. Someone cuts you off. For a split second, your brain
                  explodes with outrage. Your heart rate jumps. Your muscles
                  tense. You reach for the horn. And then... you stop.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  What happened? That tiny moment, barely noticeable and often
                  lasting less than a second, is one of the most remarkable
                  things the human brain can do. It is emotional regulation.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Most of us think intelligence is about solving problems,
                  remembering facts, or performing well on tests. Yet some of
                  the most important decisions we make have nothing to do with
                  traditional views of intelligence at all. They happen in the
                  moments when we are angry, frightened, embarrassed, jealous,
                  disappointed, or overwhelmed.
                </p>
              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/emotional_regulation.png"
                  alt="Emotional Regulation"
                  className="w-full max-w-[700px]"
                />
              </div>
            </div>

            {/* Full Width Text */}
            <div className="mt-2">
              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In those moments, the question isn't, what do you know? It's,
                can you control yourself? And that's where emotional regulation
                comes in.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Emotional regulation is not about suppressing emotions. It's not
                about becoming cold, detached, or robotic. Quite the opposite.
                Emotional regulation is the ability to experience emotions fully
                while still deciding how you want to respond to them.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                It is the difference between feeling anger and acting angrily.
                Feeling fear and being controlled by it. Feeling disappointment
                and allowing it to ruin your day.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Neuroscience has revealed that this ability depends on an
                ongoing conversation between the emotional centres of the brain,
                including the amygdala, and the frontal lobes — the seat of
                executive function. One sounds the alarm; the other decides what
                to do about it.
              </p>

              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In <em>Think Before You Think</em>, you'll discover why
                emotional regulation may be one of the most important executive
                functions of all, how it develops from childhood onwards, why
                hunger, stress, illness and poor sleep can undermine it, and how
                neuroscience is beginning to show that it can be strengthened
                through training.
              </p>

              {/* Creyos Test Button */}
              <div className="mt-12 text-center">
                <a
                  href="https://habstudy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
                >
                  IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE,
                  CLICK HERE
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EmotionalRegulation;
